module.exports = __webpack_public_path__ + "static/media/2_V_cut.c797f58e.png";